const routes = {
    // Public routes
    home: '/',
    login: '/dang-nhap',
    register: '/dang-ky',
    forgotPassword: '/quen-mat-khau',
    contact: '/lien-he',
    spa: '/dich-vu',
    spaFilter: '/dich-vu/filter',
    spaDetail: '/dich-vu-chi-tiet/:service_id',
    comboServiceDetail: '/goi-dich-vu-chi-tiet/:combo_service_id',
    policy: '/chinh-sach-bao-mat-thanh-toan',
    policyPost: '/chinh-sach/:slug',

    // Private routes
    topUp: '/nap-tien',
    withdraw: '/rut-tien',
    historyTopUp: '/lich-su-giao-dich',
    historyWithdraw: '/lich-su-rut-tien',
    profile: '/ho-so',
    editProfile: '/sua-thong-tin',
    changePass: '/doi-mat-khau',
    historyBooking: '/lich-dat',
    detailBooking: '/lich-dat/:booking_id',
    createSchedulePage: '/dat-lich',
    createSchedulePageDetail: '/dat-lich/:service_id',
    doubleSchedule: '/dat-lich-lai/:booking_id',
    downLineCollab: '/ctv-tuyen-duoi',
    shareCollab: '/chia-se-ctv',
    topUpDetail: '/thong-tin-nap-tien/:topUp_id',
    voucherDetail: '/thong-tin-voucher/:voucher_id',

    // Product
    products: '/san-pham',
    productDetail: '/thong-tin-san-pham/:product_id',
    productsFilter: '/san-pham/filter',

    // Order
    orders: '/don-hang',
    detailOrder: '/don-hang/:order_id',

    // Cart
    cart: '/gio-hang',
    checkOut: '/dat-hang',
    doubleCheckOut: '/dat-hang-lai/:order_id',

    // Card
    card: '/the-cua-toi',
    useCard: '/nguoi-dung-the',
    useCardDetail: '/thong-tin-nguoi-dung-the',

    // Combo Service
    checkOutComboService: '/dat-goi-dich-vu',
    doubleCheckOutComboService: '/dat-goi-dich-vu-lai/:order_id',

    // ReceiveRewarded
    receiveRewarded: '/nhan-thuong/:code',

    //Notification
    notification: '/thong-bao',
    downloadAPP: '/tai-ngay',
    middleShare: '/dieu-huong-chia-se',

    //Page not found
    pageNotFound: '/*',

    // Post detail
    postDetail: '/bai-viet/:post_id',

    //Personal
    personalPage: '/trang-ca-nhan',

    scan: '/scan',

    notiDetail: '/chi-tiet-thong-bao/:post_id',

    histotyUseCard: '/trang-ca-nhan/lich-su-dung-the',
};

export default routes;
